import React, { useState } from 'react';
import {
  ConfirmModal,
  Text,
  RadioGroup,
  Conditional,
} from '@cashfree-intl/coherent';

import { PAYPAL_DOCS_LINK } from '../../constants';
import { StyledConnectPaypalRadioButton, StyledConnectPaypalCheckbox } from '../styled';
import { CONNECT_PAYPAL_RADIO_OPTIONS } from './constants';

const ConnectPaypal = ({
  closeModal,
  connectPaypal,
}: {
  connectPaypal: () => void;
  closeModal: () => void;
}) => {
  const [selected, setSelected] = useState('');
  const [checkboxSelected, setCheckbox] = useState(false);

  const handleRadioOptions = obj => ({
    ...obj,
    onChange: () => {
      setSelected(obj.value);
    },
    checked: selected === obj.value,
  });

  let disableConfirmButton = true;

  if (selected === 'signup') disableConfirmButton = false;
  else if (selected === 'login') disableConfirmButton = !checkboxSelected;

  return (
    <ConfirmModal
      title="Enable Paypal"
      confirmText="Connect Account"
      onClose={closeModal}
      onConfirm={connectPaypal}
      confirmBtnEvent="Primary_Button_Enable_Paypal_Confirm"
      closeBtnEvent="Link_Button_Enable_Paypal_Cancel"
      closeCrossEvent="Enable_Paypal_Icon_Close"
      $maxWidth={620}
      confirmButtonProps={{ disabled: disableConfirmButton }}
    >
      <Text>
        To enable PayPal payment method you need to connect your PayPal account
        with Cashfree Payments.
        <br />
        <br />
        PayPal gets enabled immediately if you have an active PayPal account.
        <br />
        Refer for{' '}
        <a target="_blank" href={PAYPAL_DOCS_LINK}>
          detailed steps
        </a>{' '}
        here.
        <br />
        <br />
        <StyledConnectPaypalRadioButton>
          <RadioGroup
            fieldLabel=""
            radioOptions={CONNECT_PAYPAL_RADIO_OPTIONS.map(handleRadioOptions)}
          />
        </StyledConnectPaypalRadioButton>
        <Conditional if={selected === 'login'}>
          <StyledConnectPaypalCheckbox
            label="I have an INDIAN seller account with Paypal to be used via Cashfree PG"
            data-event-name="Connect_Paypal_Account_Checkbox"
            checked={checkboxSelected}
            onChange={(e, data) => setCheckbox(data.checked)}
          />
        </Conditional>
        <Conditional if={selected === 'signup'}>
          Note: Please select country India to successfully connect your PayPal
          seller account to Cashfree merchant dashboard.
        </Conditional>
      </Text>
    </ConfirmModal>
  );
};

export default ConnectPaypal;
